import { render, staticRenderFns } from "./DeactivateTruck.vue?vue&type=template&id=18b5d8be&scoped=true"
import script from "./DeactivateTruck.vue?vue&type=script&lang=js"
export * from "./DeactivateTruck.vue?vue&type=script&lang=js"
import style0 from "./DeactivateTruck.vue?vue&type=style&index=0&id=18b5d8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5d8be",
  null
  
)

export default component.exports